import { useEffect, useState } from "react";

import CandidateList from "./CandidateList";
import CandidateCreate from "./CandidateCreate";
import { Dialog } from "primereact/dialog";
import { candidateService } from "../../service/Candidate/candidate.service";
import { ICandidate } from "./Candidate.model";
import { Card } from "primereact/card";

const Candidate = () => {
  const [candidateDialog, setCandidateDialog] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<ICandidate[]>([]);
  const openNew = () => {
    setCandidateDialog(true);
  };

  const hideDialog = () => {
    setCandidateDialog(false);
  };

  useEffect(() => {
    loadCandidates();
  }, []);

  const loadCandidates = async () => {
    setLoading(true);
    const res = await candidateService.getAll();
    const sortedData = [...res.data].sort((a, b) => a.id - b.id);
    setData(sortedData);
    setLoading(false);
  };

  return (
    <>
      <Card>
        <Dialog
          visible={candidateDialog}
          header={"Candidate Details"}
          modal
          onHide={() => hideDialog()}
          style={{ width: "50vw" }}>
          <CandidateCreate
            setCandidateDialog={setCandidateDialog}
            loadCandidates={loadCandidates}
          />
        </Dialog>
        <CandidateList
          openNew={openNew}
          loading={loading}
          data={data}
          loadCandidates={loadCandidates}
        />
      </Card>
    </>
  );
};

export default Candidate;
